define(function(require, exports, module) {

    var $ = null,
        appHelper = {},

        beforeLoadHTML = "<span>下拉刷新</span>",
        releaseLoadHTML = "<span>释放立即刷新</span>",
        loadSuccessHTML = "<span>加载成功</span>",
        loadErrorHTML = "<span>加载失败，请稍后再试</span>",
        noMoreHTML = "<span>没有更多了,请稍后再试</span>",
        noMoreNoStartHTML = "<span>没有更多了</span>",
        LoadingHTML = "<i class='icon'></i><span>正在加载中...</span>",


        tool = {

            init: function(jquery, _appHelper) {
                $ = jquery;

                if (_appHelper) {
                    var option = ['bindGlobalFunc', 'checkApp', 'checkLogin', 'checkAppLogin', 'checkTYSNAV', 'alert', 'showConfirm', 'showLoading', 'hideLoading', 'onAppEvent', 'offAppEvent', 'onAppReady', 'reloadPage', 'pipe'];
                    for (var i = 0; i < option.length; i++) {
                        tool[option[i]] = _appHelper[option[i]];
                    }
                }

                return tool;
            },

            /**
             * wait时间之内只执行一次
             * @param url
             * @param data
             * @returns {string}
             */
            debounce: (function () {

                var time = new Date().getTime();
                return function (func, wait) {
                    var ctime = new Date().getTime();
                    if (ctime - time > wait) {
                        func();
                        time = ctime;
                    }
                }
            })(),

            debounce2: function (func, wait) {
				// 获取初始化时间戳
				var then = new Date().getTime()
				// 返回函数
				return function () {
					var now = new Date().getTime()
					// 如果
					if (now - then > wait) {
						func.apply(null, arguments)
						then = now
					}
				}
			},

            tmpl: function(string, data) {
                var _str = string;
                $.each(data, function(key, value) {
                    _str = _str.replace(new RegExp('{{' + key + '}}', 'g'), value);
                });
                return _str;
            },

            getType: function(data) {
                return Object.prototype.toString.call(data).replace(/(^\[object )|(\]$)/g, '');
            },

            stopDefault: function(e) {
                //阻止默认浏览器动作(W3C) 
                if (e && e.preventDefault)
                    e.preventDefault();
                //IE中阻止函数器默认动作的方式 
                else
                    window.event.returnValue = false;
                return false;
            },

            stopBubble: function(e) {
                //如果提供了事件对象，则这是一个非IE浏览器 
                if (e && e.stopPropagation)
                //因此它支持W3C的stopPropagation()方法 
                    e.stopPropagation();
                else
                //否则，我们需要使用IE的方式来取消事件冒泡 
                    window.event.cancelBubble = true;
            },

            /**
             * 打印一个对象到控制台
             * @param {Object} target
             */
            log: function(target) {
                var _res = [];
                if (tool.getType(target) === 'array' || tool.getType(target) === 'object') {
                    $.each(target, function(key, val) {
                        _res.push(key + ':' + key);
                    });
                    _res = _res.join(',');
                } else {
                    _res = target;
                }
                console && typeof(console.log) === 'function' && console.log(_res);
            },

            // 对Date的扩展，将 Date 转化为指定格式的String
            // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符， 
            // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) 
            // 例子： 
            // (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423 
            // (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18 
            formatDate: function(date, fmt) { //author: meizz 
                var d = new Date(date);
                fmt = fmt || "yyyy-MM-dd";
                var o = {
                    "M+": d.getMonth() + 1, //月份 
                    "d+": d.getDate(), //日 
                    "h+": d.getHours(), //小时 
                    "m+": d.getMinutes(), //分 
                    "s+": d.getSeconds(), //秒 
                    "q+": Math.floor((d.getMonth() + 3) / 3), //季度 
                    "S": d.getMilliseconds() //毫秒 
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            },

            isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1, //android终端

            isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端

            isPhone: function() {
                var sUserAgent = navigator.userAgent.toLowerCase();
                var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                var bIsMidp = sUserAgent.match(/midp/i) == "midp";
                var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                var bIsAndroid = sUserAgent.match(/android/i) == "android";
                var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                if (bIsIpad || bIsMidp || bIsIphoneOs || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                    return true;
                } else {
                    return false;
                }
            },

            /**
             * 获取显示宽度
             */
            getClientWidth: function() {
                return document.documentElement.clientWidth || document.body.clientWidth;
            },

            /**
             * 获取显示高度
             */
            getClientHeight: function() {
                return document.documentElement.clientHeight || document.body.clientHeight;
            },

            /**
             * 获取文档高度
             */
            getScrollHeight: function() {
                return document.documentElement.scrollHeight || document.body.scrollHeight;
            },

            /**
             * 获取隐藏域的值
             * @param {String} selector 隐藏域集合的选择器
             */
            getHiddenValues: function(selector) {
                var res = {};
                var container = $(selector);
                container.find('input[type=hidden]').each(function(i, input) {
                    var $input = $(input);
                    res[$input.attr('name')] = $input.val();
                });
                container.find('textarea').each(function(i, input) {
                    var $input = $(input);
                    res[$input.attr('name')] = $.parseJSON($input.val());
                });
                return res;
            },

            /**
             * 将数字转化为金钱的显示方式
             * @param {number} money
             */
            toMoney: function(money) {
                if (money === 0) {
                    return '0.00';
                }
                money = Math.round(money * 100);
                money = '' + money;
                if (money.length === 1) {
                    return '0.0' + money;
                } else if (money.length === 2) {
                    return '0.' + money;
                } else {
                    return money.slice(0, money.length - 2) + '.' + money.slice(money.length - 2, money.length);
                }
            },

            /**
             * 将字符串转化为数字
             * @param {String} str
             */
            toNumber: function(str) {
                return parseFloat(str);
            },

            parseJson: function (str, init) {
                try {
                    return JSON.parse(str) || init
                } catch (e) {
                    return init
                }
            },

            /**
             * 
             */
            onWindowScroll: (function() {
                var funcs = {},
                    $win = null,
                    started = false;

                function start() {
                    if (started) {
                        return;
                    }
                    $win = $(window);
                    started = true;
                    $win.on('scroll', function(e) {
                        var scrollTop = $win.scrollTop();
                        $.each(funcs, function(k, func) {
                            func.call(e, e, scrollTop);
                        });
                    });
                }
                return {
                    on: function(func) {
                        start();
                        var key = new Date().getTime();
                        funcs[key] = func;
                        $win.trigger('scroll');
                    },
                    off: function(key) {
                        start();
                        delete funcs[key];
                    },
                    clear: function() {
                        start();
                        funcs = {};
                    },
                    trigger: function() {
                        start();
                        $win.trigger('scroll');
                    }
                }
            })(),

            scrollTo: (function() {
                var body = null,
                    win = null;
                return function(target, offsetTop) {
                    if (offsetTop === undefined) {
                        offsetTop = 40;
                    }
                    body = body || $('body');
                    win = win || $(window);
                    var currentTop = win.scrollTop();
                    if (typeof(target) === 'number') {
                        var targetTop = target;
                    } else {
                        var position = target.offset(),
                            targetTop = position.top - offsetTop;
                    }

                    body.css({ defineTop: 0 });
                    body.animate({
                        defineTop: targetTop - currentTop
                    }, {
                        speed: 500,
                        easing: 'swing',
                        queue: false,
                        step: function(top) {
                            win.scrollTop(currentTop + top);
                        }
                    });
                }
            })(),

            fixNum: function(num) {
                return num < 10 ? ('0' + num) : num;
            },

            funTransitionHeight: function(element, time) { // time, 数值，可缺省
                if (typeof window.getComputedStyle == "undefined") return;

                var height = window.getComputedStyle(element).height;
                element.style.height = "auto";
                var targetHeight = window.getComputedStyle(element).height;
                element.style.height = height;
                setTimeout(function() {
                    if (time) element.style.transition = "height " + time + "ms";
                    element.style.height = targetHeight;
                }, 15);
                return tool;
            },

            fixHeight: function(el1, el2) {
                el2.css('height', el1.height());
                return tool;
            },

            fixTitle: function(data) {
                if (data.title) {
                    document.title = data.title;
                }
                return tool;
            },

            max: function(array) {
                if (array.length === 0) {
                    return NaN;
                } else if (array.length === 1) {
                    return array[0];
                } else {
                    var _max = array[0];
                    for (var i = 1, j = array.length; i < j; i++) {
                        _max = Math.max(_max, array[i]);
                    }
                    return _max;
                }
            },

            min: function(array) {
                if (array.length === 0) {
                    return NaN;
                } else if (array.length === 1) {
                    return array[0];
                } else {
                    var _min = array[0];
                    for (var i = 1, j = array.length; i < j; i++) {
                        _min = Math.min(_min, array[i]);
                    }
                    return _min;
                }
            },

            /*
             * 把一段事件格式化为多少天多少小时多少秒
             * @param 需要格式化的时间段  为毫秒数
             * @param 返回数据的前缀
             */
            formatTime: function(time, prefix) {
                var miniSeconds = 1,
                    dayTime = miniSeconds * 60 * 60 * 24,
                    days = 0,
                    hourTime = miniSeconds * 60 * 60,
                    hours = 0,
                    minuteTime = miniSeconds * 60,
                    minutes = 0,
                    secondTime = miniSeconds,
                    seconds = 0,
                    res = [prefix || ''];

                if (time >= dayTime) {
                    days = Math.floor(time / dayTime);
                    res.push(tool.fixNum(days) + '天')
                    time -= days * dayTime;
                } else {
                    res.push('00天');
                }
                if (time >= hourTime) {
                    hours = Math.floor(time / hourTime);
                    res.push(tool.fixNum(hours) + '时')
                    time -= hours * hourTime;
                } else {
                    res.push('00时');
                }
                if (time >= minuteTime) {
                    minutes = Math.floor(time / minuteTime);
                    res.push(tool.fixNum(minutes) + '分')
                    time -= minutes * minuteTime;
                } else {
                    res.push('00分');
                }
                if (time >= secondTime) {
                    seconds = Math.floor(time / secondTime);
                    res.push(tool.fixNum(seconds) + '秒')
                    time -= seconds * secondTime;
                } else {
                    res.push('00秒');
                }
                return res.join('');
            },

            checkJSON: function(data) {
                if (typeof(data) === 'string') {
                    data = $.parseJSON(data);
                }
                return data;
            },

            /*
             * 批量设置avalon的vmodel里面的值
             * @param vm avalon的vmodel
             * @param target 需要插入的值
             */
            setVMValues: function(vm, target, key) {
                var _key = '',
                    _obj = null;

                if (key) {
                    vm = eval('vm.' + key);
                }

                for (var name in target) {
                    _obj = target[name];
                    if (vm[name] !== undefined) {
                        _key = name;
                    }
                    if (vm['$' + name] !== undefined) {
                        _key = '$' + name;
                    }
                    if (_key !== '') {
                        if (typeof(vm[_key]) === 'object' && typeof(target[name]) !== 'object') {
                            _obj = $.parseJSON(target[name]);
                        }
                        vm[_key] = _obj
                    }
                    _obj = null;
                    _key = '';
                }

                return tool;
            },

            /**
             * 单例的方法，同一时间只能运行一次，除非触发了完成
             */
            singleWay: (function() {

                var fgs = {},
                    kit = {
                        resolve: function(key) {
                            fgs[key] = false;
                        }
                    };

                return function(key, func) {
                    if (fgs[key] === true) {
                        return;
                    } else {
                        fgs[key] = true;
                        func.call(kit, key);
                    }
                }

            })(),

            /**
             * 延时500毫秒执行函数
             */
            delay: function(func) {
                return setTimeout(function() {
                    func && func();
                }, 500);
            },

            /**
             * 检查数据里面是否存在该节点
             * @param {Array} array 需要检查的数组
             * @param {Object} target 需要检查的对象或者简单数据类型
             * @param {String} key 如果需要检查的对象只需匹配某个属性的值相同则认为对象相等
             * @return {boolean} 存在返回true 不存在返回false
             */
            checkExistInArray: function(array, target, key) {
                if (array.length > 0) {
                    var res = false;
                    for (var i in array) {
                        if (key) {
                            if (array[i][key] === target[key]) {
                                return true;
                            }
                        } else {
                            if (array[i] === target) {
                                return true;
                            }
                        }
                    }
                    return false;
                } else {
                    return false;
                }
            },

            /**
             * 向北京的统计服务器发送埋点的统计，目前仅统计商城
             * @param {String} type app => 访问的app链接  pc => 访问的pc链接
             * @param {String} action 操作，由北京定义 (如step100，step200)
             * @param {String} userid 用户id
             * @param {Object} param 某些特定的action需要增加的参数
             * @param {String} from 统计的网站： mall=>商城  (默认为mall)
             */
            sendEventTracking: function(type, action, param, userid, from) {
                // if(typeof userid == "undefined"){
                // 	userid = $("[name='userid']").val();
                // }
                // var data = {
                // 	type: type,
                // 	action: action,
                // 	userid: userid
                // };
                // for(var i in param){
                // 	data[i] = param[i];
                // }
                // $.ajax({
                // 	url: "http://210.14.143.210/",
                // 	data: data,
                // 	dataType: "jsonp"
                // }).done(function(response){
                // 	//console.log(response);
                // });
            },

            /**
             *	获取浏览器所带的参数
             * @returns {}
             */
            getUrlParams: function() {
                var url = window.location.href;
                var indexQ = url.indexOf('?');
                var indexJ = url.indexOf('#');
                if (indexJ === -1) {
                    indexJ = url.length;
                }
                var url2 = url.slice(indexQ + 1, indexJ);
                var url3 = url.slice(indexJ + 1);

                function toParam(str) {
                    var _param = str.split('&'),
                        _res = {};
                    $.each(_param, function(i, _str) {
                        var key = _str.split('=')[0];
                        var value = _str.split('=')[1];
                        _res[key] = value;
                    });
                    return _res;
                }

                var res = {};
                if (indexQ !== -1) {
                    res = toParam(url2);
                }
                if (indexJ !== -1) {
                    res = $.extend(true, res, toParam(url3));
                }
                return res;
            },

            /**
             * 给链接添加参数
             * @param url
             * @param data
             * @returns {string}
             */
            addParamToUrl: function(url, data) {
                var res = [];
                $.each(data, function(key, val) {
                    res.push(key + '=' + val);
                });
                res = res.join('&');
                if (url.indexOf('?') !== -1) {
                    url += '&' + res;
                } else {
                    url += '?' + res;
                }
                return url;
            },
            /**
             * wait时间之内只执行一次
             * @param url
             * @param data
             * @returns {string}
             */
            debounce: (function() {

                var time = new Date().getTime();
                return function(func, wait) {
                    var ctime = new Date().getTime();
                    if (ctime - time > wait) {
                        func();
                        time = ctime;
                    }
                }
            })(),

            
            debounce2: function (func, wait) {
				// 获取初始化时间戳
				var then = new Date().getTime()
				// 返回函数
				return function () {
					var now = new Date().getTime()
					// 如果
					if (now - then > wait) {
						func.apply(null, arguments)
						then = now
					}
				}
			},

            bindGlobalFunc: appHelper.bindGlobalFunc,

            /*
             * @return 		json(app:是不是APP，version:APP的版本号如果不是APP则返回0)
             * */
            checkApp: appHelper.checkApp,

            /*
             * 低于等于APP 2.4
             * 打开App的登录界面
             * */
            checkLogin: appHelper.checkLogin,

            /*
             * 高于等于App 2.5
             * 打开App的登录界面
             * 解决App和webview登录的问题
             * */
            checkAppLogin: appHelper.checkAppLogin,


            /*
             * @param:func 		function 检测TYSNAV成功执行回调
             * @param:version 	number 	   对APP进行版本检测
             * @param:error		function 检测失败执行的回调 （none:不存在TYSNAV，notapp:不在APP中打开，notsupport:版本不支持）
             * */
            checkTYSNAV: appHelper.checkTYSNAV,

            /*
             * @param:msg		提示的消息内容
             * */
            alert: appHelper.alert,

            showConfirm: appHelper.showConfirm,

            // APP专用
            showLoading: appHelper.showLoading,

            // APP专用
            hideLoading: appHelper.hideLoading,

            onAppEvent: appHelper.onAppEvent,

            offAppEvent: appHelper.offAppEvent,

            onAppReady: appHelper.onAppReady,

            reloadPage: appHelper.reloadPage,

            /* 
             * 当滚动条滚动到页面底部的时候触发回调
             * @param callback 	回调的函数
             * @param firstLoad boolean是否默认加载一次 
             */
            onScrollBottom: function(callback, firstLoad) {
                tool.onWindowScroll.on(function() {

                    var array = [].slice.call(arguments),
                        st = array[1],
                        sh = tool.getScrollHeight(),
                        ch = tool.getClientHeight();

                    if (sh - (st + ch) < 30) {
                        array.push(sh);
                        array.push(ch);
                        callback.apply(document, array);
                    }

                });

                if (firstLoad) {
                    callback.apply(document);
                }

                return tool;
            },

            /*
             * 当有弹出层的时候固定背景
             * 该方法会在window上新增一个变量 FIXSCROLLTOP， 用来记录当前滚动条高度
             * @param fixing true 固定，false取消固定
             * @param time 延迟执行时间
             */
            fixBody: function(fixing, time, defaultWidth) {
                var scrollTop,
                    defaultWidth = defaultWidth || 550;
                if (fixing) {
                    var fix = function() {
                        scrollTop = $(document).scrollTop();
                        window.FIXSCROLLTOP = scrollTop;
                        $('body').css({
                            position: 'fixed',
                            top: (-scrollTop),
                            width: window.screen.width > defaultWidth ? defaultWidth : window.screen.width,
                            left: window.screen.width > defaultWidth ? (window.screen.width - defaultWidth) / 2 : 0
                        });
                    };

                    (time && setTimeout(fix, time)) || fix();
                } else {
                    scrollTop = window.FIXSCROLLTOP || 0;
                    $('body').css({
                        position: 'static',
                        top: 0,
                        width: 'auto',
                        left: 0
                    });
                    $(document).scrollTop(scrollTop);
                }

                return tool;
            },

            scrollUtil: (function() {

                var _dis = 10, // 离底部x像素就算到底部了
                    _res = {
                        isBottom: function(bottomHeight) {
                            bottomHeight = typeof(bottomHeight) === 'undefined' ? 0 : bottomHeight;
                            var st = $(window).scrollTop(),
                                sh = tool.getScrollHeight(),
                                ch = tool.getClientHeight();

                            //							tool.log({
                            //								st: st,
                            //								sh: sh,
                            //								ch: ch,
                            //								'st+ch': st+ch,
                            //								'sh-bottomHeight': sh-bottomHeight
                            //							});

                            // 当内容高度小于等于屏幕高度
                            if (sh <= ch) {
                                return true;
                            } else {
                                if ((st + ch) > (sh - bottomHeight - _dis)) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        },
                        /**
                         * 
                         * @param {Number} bottomHeight
                         * @param {Function} callback
                         */
                        onBottom: function(bottomHeight, callback) {
                            tool.onWindowScroll.on(function() {
                                if (_res.isBottom(bottomHeight)) {
                                    callback && callback();
                                }
                            });
                        },
                        /**
                         * 通过windowscroll事件判断加载更多
                         * @param {Number} bottomHeight
                         * @param {Object} vmodel
                         * @param {String} htmlKey
                         * @param {Function} callback
                         */
                        addLoadMore: function(bottomHeight, vmodel, htmlKey, callback) {
                            var _loading = false,
                                _nomore = false,
                                _timer = 0,
                                _request = null,
                                _kit = {
                                    success: function() {
                                        clearTimeout(_timer);
                                        _loading = false;
                                        vmodel[htmlKey] = loadSuccessHTML;
                                    },
                                    error: function() {
                                        clearTimeout(_timer);
                                        vmodel[htmlKey] = loadErrorHTML;
                                        _timer = setTimeout(function() {
                                            vmodel[htmlKey] = LoadingHTML;
                                            _request = callback();
                                        }, 5000);
                                    },
                                    noMoreNoStart: function() {
                                        clearTimeout(_timer);
                                        _nomore = true;
                                        _loading = false;
                                        vmodel[htmlKey] = noMoreNoStartHTML;
                                    },
                                    nomore: function() {
                                        clearTimeout(_timer);
                                        vmodel[htmlKey] = noMoreHTML;
                                        setTimeout(function() {
                                            _loading = false;
                                        }, 5000);
                                    },
                                    reset: function() {
                                        clearTimeout(_timer);
                                        _loading = false;
                                        _nomore = false;
                                        vmodel[htmlKey] = LoadingHTML;
                                        _request && _request.abort && _request.abort();
                                    },
                                    loadMore: function() {
                                        _callback();
                                    }
                                },
                                _callback = function() {
                                    if (_loading) {
                                        return;
                                    } else if (_nomore === false) {
                                        vmodel[htmlKey] = LoadingHTML;
                                        _loading = true;
                                        _request = callback();
                                    } else {
                                        vmodel[htmlKey] = noMoreNoStartHTML;
                                    }
                                };

                            _res.onBottom(bottomHeight, function() {
                                setTimeout(function() {
                                    _callback();
                                }, 10)
                            });
                            return _kit;
                        },
                        clear: function() {
                            tool.onWindowScroll.clear();
                        }
                    }

                return _res;

            })(),

            /**
             * 图片排版类
             */
            picLayout: (function() {
                var winWidth = document.documentElement.clientWidth || document.body.clientWidth,
                    displayWidth = winWidth - 10 - 20,
                    imgMargin = 5,
                    config = {
                        1: {
                            width: displayWidth,
                            height: (displayWidth - imgMargin) / 2
                        },
                        2: {
                            width: (displayWidth - imgMargin) / 2,
                            height: (displayWidth - imgMargin) / 2
                        },
                        3: {
                            width: (displayWidth - imgMargin * 2) / 3,
                            height: (displayWidth - imgMargin * 2) / 3
                        }
                    };

                return {
                    /**
                     * 给imgs设计出图片显示宽高
                     * @param {Array} target
                     * @param {String} key
                     */
                    fix: function(target, key) {
                        $.each(target, function(i, obj) {
                            var _config = null;
                            if (obj[key].length === 1) {
                                _config = config[1];
                            } else if (obj[key].length === 2) {
                                _config = config[2];
                            } else if (obj[key].length === 3) {
                                _config = config[3];
                            }

                            if (_config) {
                                obj.displayWidth = _config.width;
                                obj.displayHeight = _config.height;
                            }
                        });
                    },
                    getConfig: function(borderWidth, imgMargin) {
                        displayWidth = winWidth - borderWidth;
                        return {
                            1: {
                                width: displayWidth,
                                height: (displayWidth - imgMargin) / 2
                            },
                            2: {
                                width: (displayWidth - imgMargin) / 2,
                                height: (displayWidth - imgMargin) / 2
                            },
                            3: {
                                width: (displayWidth - imgMargin * 2) / 3,
                                height: (displayWidth - imgMargin * 2) / 3
                            }
                        };
                    }
                }
            })(),



            /*
             * 用ISCROLL 实现的 下拉刷新 和 上拉加载更多
             */
            iscrollKit: (function() {

                return {
                    addRefresh: function(scrollInstance, vmodel, htmlKey, displayKey, loadingKey, callback) {

                        var timer = 0;
                        var kit = {
                            loadSuccess: function() {
                                vmodel[htmlKey] = loadSuccessHTML;
                                clearTimeout(timer);
                                timer = setTimeout(function() {
                                    scrollInstance.scrollTo(0, 0, 600, scrollInstance.options.bounceEasing);
                                    vmodel[htmlKey] = '';
                                    vmodel[displayKey] = false;
                                    vmodel[loadingKey] = false;
                                    scrollInstance.offsetY = 0;
                                }, 1000);
                            },
                            loadError: function() {
                                vmodel[htmlKey] = loadErrorHTML;
                                clearTimeout(timer);
                                timer = setTimeout(function() {
                                    scrollInstance.scrollTo(0, 0, 600, scrollInstance.options.bounceEasing);
                                    vmodel[htmlKey] = '';
                                    vmodel[displayKey] = false;
                                    vmodel[loadingKey] = false;
                                    scrollInstance.offsetY = 0;
                                }, 1000);
                            },
                            loadEmpty: this.loadSuccess,
                            release: function() {
                                scrollInstance.scrollTo(0, 0);
                                vmodel[htmlKey] = '';
                                vmodel[displayKey] = false;
                                vmodel[loadingKey] = false;
                                scrollInstance.offsetY = 0;
                            }
                        }

                        scrollInstance.on('scroll', function() {
                            if (!vmodel[loadingKey]) {
                                if (this.y > 0 && this.y < 50) {
                                    vmodel[displayKey] = true;
                                    vmodel[htmlKey] = beforeLoadHTML;
                                } else if (this.y >= 50) {
                                    vmodel[htmlKey] = releaseLoadHTML;
                                }
                            }
                        });

                        scrollInstance.on('touchEnd', function() {
                            if (this.y >= 50 && !vmodel[loadingKey]) {
                                vmodel[htmlKey] = LoadingHTML;
                                scrollInstance.offsetY = 50;
                                vmodel[loadingKey] = true;
                                callback && callback.call(kit);
                            }
                        });

                        return {
                            refresh: function() {
                                vmodel[displayKey] = true;
                                vmodel[loadingKey] = true;
                                vmodel[htmlKey] = LoadingHTML;
                                scrollInstance.offsetY = 50;
                                scrollInstance.scrollTo(0, 50);
                                callback && callback.call(kit);
                            }
                        }

                    },
                    addLoadMore: function(scrollInstance, vmodel, htmlKey, displayKey, loadingKey, callback) {
                        var timer = 0;
                        var kit = {
                            loadSuccess: function() {
                                vmodel[htmlKey] = loadSuccessHTML;
                                clearTimeout(timer);
                                timer = setTimeout(function() {
                                    vmodel[htmlKey] = '';
                                    vmodel[displayKey] = false;
                                    vmodel[loadingKey] = false;
                                    scrollInstance.refresh();
                                }, 1000);
                            },
                            loadEmpty: function() {
                                vmodel[htmlKey] = noMoreHTML;
                                clearTimeout(timer);
                                timer = setTimeout(function() {
                                    vmodel[htmlKey] = '';
                                    vmodel[displayKey] = false;
                                    vmodel[loadingKey] = false;
                                    scrollInstance.refresh();
                                }, 1000);
                            },
                            loadError: function() {
                                vmodel[htmlKey] = loadErrorHTML;
                                clearTimeout(timer);
                                timer = setTimeout(function() {
                                    vmodel[htmlKey] = '';
                                    vmodel[displayKey] = false;
                                    vmodel[loadingKey] = false;
                                    scrollInstance.refresh();
                                }, 1000);
                            },
                            release: function() {
                                scrollInstance.scrollTo(0, 0);
                                vmodel[htmlKey] = '';
                                vmodel[displayKey] = false;
                                vmodel[loadingKey] = false;
                            }
                        }

                        scrollInstance.on('scroll', function() {
                            if (this.maxScrollY - this.y > 10 && !vmodel[loadingKey]) {
                                vmodel[htmlKey] = LoadingHTML;
                                vmodel[loadingKey] = true;
                                vmodel[displayKey] = true;
                                callback && callback.call(kit);
                                scrollInstance.refresh();
                            }
                        });

                        //						scrollInstance.on('touchEnd', function(){
                        //							if (this.y >= 50 && !vmodel[loadingKey]) {
                        //								vmodel[htmlKey] = LoadingHTML;
                        //								scrollInstance.offsetY = 50;
                        //								vmodel[loadingKey] = true;
                        //								callback && callback.call(kit);
                        //							}
                        //						});

                    }
                }
            })()
        };

    return tool;
});